<template>
  <div class="text-center">
    <q-btn v-if="!firma" label="Captura Firma" color="primary" @click="open" />

    <div v-else>
      <img :src="firma" class="responsive" alt="" style="width:90%">
      <q-btn label="Enviar" @click="storeFirma" />
      <q-btn label="Cancelar" @click="setFirma({})" />
    </div>

    <q-dialog v-model="openModal"
      persistent
      :maximized="maximizedToggle"
      transition-show="slide-up"
      transition-hide="slide-down">

      <q-card id="card-firma">
        <q-card-section>
          pedido nº: {{pedido_id}}
        </q-card-section>
        
        <q-card-section>
          <VueSignaturePad
            :width="width"
            :height="height"
            :options="options"
            :images="images"
            saveType="image/jpeg" 
            ref="signaturePad"
            :customStyle="stylePad"
            id="canvas-firma"
          />
        </q-card-section>

        <q-card-actions align="center">
          <q-btn outline color="primary" label="Guardar" size="sm" @click="save" v-close-popup/>
          <q-btn outline color="secondary" label="Revertir" size="sm" @click="undo" />
          <q-btn outline color="secondary" label="Borrar" size="sm" @click="clear" />
          <q-btn outline label="Cancel" color="primary" size="sm" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>

  </div>
</template>

<script>
import Vue from 'vue'
import {authHeader} from './../_helpers/_auth-header'
// import {dataURItoBlob} from './../_helpers/dataURItoBlob'
import axios from 'axios'
import { mapMutations, mapActions } from 'vuex'
import VueSignaturePad from 'vue-signature-pad'

Vue.use(VueSignaturePad);

export default {
  props: ['empresa_id', 'pedido_id'],
  name: 'FirmaDialog',
  data() {
    return {
      openModal: false,
      maximizedToggle: true,
      width: '',
      height: '',
      options: {
        // backgroundColor: 'rgb(221, 221, 221)', //gris
        backgroundColor: 'rgb(255, 255, 255)',
        // backgroundColor: 'rgba(0,0,0,0)', //con transparencia para png
      },
      stylePad: {
        border: 'lightgrey 1px solid'
        // border: 0
      },
      dataURI: '',
      images: [
        // 
        'img/firma.png'
      ]
    }
  },
  computed: {
    // urlApiPedidoArchivos() {
    //   return this.$store.state.urlBase + `/api/v3/${this.empresa_id}/pedidos/archivos/${this.pedido_id}`;
    // },
    firma() {
      return this.$store.state.firma.dataURI;
    }
  },
  methods: {
    ...mapMutations(['setFirma']),
    ...mapActions(['storeFirma']),

    open() {
      this.openModal = true;
      this.$nextTick(function () {
        let panelFirma = document.getElementById('card-firma');
        console.log('card-firma: ', panelFirma.offsetWidth, panelFirma.offsetHeight);
        
        this.width = panelFirma.offsetWidth - 30 + 'px';
        this.height = panelFirma.offsetHeight - 115 + 'px';
        
        this.resizeFirma();
        console.log('mirando dimensiones');
      })
    },
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    save() {
      console.log('Guardando....');
      this.$refs.signaturePad.addImages()
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      
      if (!isEmpty) {
        this.dataURI = data;
        this.setFirma({
          dataURI: data, 
          empresa_id: this.empresa_id, 
          pedido_id: this.pedido_id
          });
        this.clear();
      } else {
        this.dataURI = '';
        this.setFirma({});
      }
    },
    clear() {
      this.$refs.signaturePad.clearSignature();
    },
    lock() {
      this.$refs.signaturePad.lockSignaturePad();
    },
    unlock() {
      this.$refs.signaturePad.openSignaturePad();
    },
    resizeFirma(event) {

      this.$nextTick(function () {
        console.log('redimensionando canva firma');
        console.log('Orientacion: ', window.orientation);
        // let canvas = document.getElementsByTagName('canvas')[0];
        // var ratio =  Math.max(window.devicePixelRatio || 1, 1);

        // console.log('canvas:',canvas.offsetWidth, canvas.offsetHeight);
        // canvas.width = canvas.offsetWidth * ratio;
        // canvas.height = canvas.offsetHeight  * ratio;
        
        // canvas.getContext("2d").scale(ratio, ratio);

        // console.log('dentro de nextTick resize');
        // this.$refs.signaturePad.clearSignature();
        if(typeof this.$refs.signaturePad !== 'undefined') {
          this.$refs.signaturePad.resizeCanvas();
        }
      })
    },
    
  },
  mounted() {
    console.log('componente firma montado');
  },
  created() {
    console.log('componente firma creado');
  },
  deactivated() {
    console.log('desactivando componente firma');
    window.removeEventListener('resize', this.resizeFirma);
    },
  activated() {
    console.log('activando componente firma');
    let cardFirma = document.getElementById('card-firma');
    // console.log('cardFirma:',cardFirma.offsetWidth, cardFirma.offsetHeight);
    window.addEventListener("resize", this.resizeFirma);
    // console.log(this.$q.platform.is);
  }
}
</script>

<style lang="scss">

</style>